module.exports = "<app-navigation></app-navigation>\n\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>"